<template>
  <span id='team-logo' :class='loadingLogo ? "team-logo-loading" : "team-logo-loadDone"' v-if='teamId !== "0"'>
    <img :src="imageUrl('jpg')"
      ref='jpgImage'
      alt="team's logo"
      v-if="!loadJPGFail"
      @error="loadImageFail('jpg')"
      @load="loadImageDone('jpg')"/>

    <img :src="imageUrl('png')"
      ref='pngImage'
      alt="team's logo"
      v-if="loadJPGFail && !loadPNGFail"
      @error="loadImageFail('png')"
      @load="loadImageDone('png')"/>

    <img :src="imageUrl('gif')"
      ref='gifImage'
      alt="team's logo"
      v-if="loadPNGFail && !loadGIFFail"
      @error="loadImageFail('gif')"
      @load="loadImageDone('gif')"/>
  </span>
</template>

<script>
import { sportID } from '@/router'

export default {
  name: 'team-logo',
  props: {
    teamId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      sportID: '1',
      loadingLogo: true,
      loadJPGFail: false,
      loadPNGFail: false,
      loadGIFFail: false
    }
  },
  watch: {
    teamId (newValue) {
      if (this.$refs.jpgImage) {
        this.$refs.jpgImage.src = ''
      }

      if (this.$refs.pngImage) {
        this.$refs.pngImage.src = ''
      }

      if (this.$refs.gifImage) {
        this.$refs.gifImage.src = ''
      }

      this.loadingLogo = true
      this.loadJPGFail = false
      this.loadPNGFail = false
      this.loadGIFFail = false
    }
  },
  methods: {
    imageUrl (type) {
      switch (this.sportID) {
        case '2':
          return `http://bdata.7m.com.cn/basketball_team_data/${this.teamId}/logo_Img/club_logo.${type}`

        case '1':
        default:
          return `http://data.7m.com.cn/team_data/${this.teamId}/logo_Img/club_logo.${type}`
      }
    },
    loadImageFail (type) {
      switch (type) {
        case 'jpg': this.loadJPGFail = true; break
        case 'png': this.loadPNGFail = true; break
        case 'gif':
          this.loadGIFFail = true
          this.loadImageDone()
          break
        default: break
      }
    },
    loadImageDone (type) {
      this.loadingAvatar = false
    }
  },
  mounted () {
    this.sportID = sportID
  }
}
</script>

<style lang="sass" scoped>
span
  background-repeat: no-repeat
  background-size: contain
  border-radius: 50%

img
  width: 100%
  height: 100%
  border-radius: 50%
  object-fit: cover

.team-logo-loading
  background-image: url(~@/assets/basketball/140Logo@2x.png)

.team-logo-loadDone
  background-image: url(~@/assets/basketball/140Team@2x.png)
</style>
